import { t } from 'i18next';
import { forwardRef } from 'react';

import LabeledInput from './LabeledInput';

const Email = forwardRef(({ labelText, validators, placeHolder, ...restOfProps }, ref) => {
    let emailValidators = [
        {
            rgx: /.+@.+\..+/,
            failText: t('Email.EnterEmailValid'),
        },
    ];

    if (validators) {
        let defaultValidators = emailValidators.values();
        for (let v1 of defaultValidators) {
            let newValidators = validators.values();
            for (let v2 of newValidators) {
                if (v1.rgx.toString() === v2.rgx.toString()) {
                    v1.failText = v2.failText;
                }
            }
        }
        emailValidators.concat(validators);
        emailValidators = [...new Set(emailValidators)];
    }

    return (
        <LabeledInput
            validators={emailValidators}
            labelText={labelText ? labelText : t('Email.EmailLabel')}
            ref={ref}
            placeholder={placeHolder ? placeHolder : t('Email.EnterEmail')}
            {...restOfProps}
        />
    );
});

Email.displayName = 'Email';

export default Email;
